import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const withNotLogged = (Component) => {
    return (props) => {
        const loggedIn = useSelector(({ auth }) => auth.login.loggedIn);
        const [isLoaded, setIsLoaded] = useState(false);

        useEffect(() => {
            setIsLoaded(true);
        }, [loggedIn]);

        if (!isLoaded) return null;

        if (!loggedIn) {
            return <Navigate to="/" replace />;
        }

        return <Component {...props} />;
    };
};
export default withNotLogged;
